import React from 'react';

// Cell style for consistent table appearance
const cellStyle = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  padding: '4px 2px',
  fontSize: '14px'
};

// Stream category config
const streamCategoryConfig = {
  live_darshan: { label: 'Live Darshan', color: '#9C27B0' },
  live_stream: { label: 'Live Stream', color: '#2196F3' },
  live_aarti: { label: 'Live Aarti', color: '#FF9800' }
};

// Define table columns
export const tableColumns = [
  {
    name: 'Stream Type',
    selector: row => row.stream_type,
    sortable: true,
    center: true,
    width: '130px',
    style: cellStyle,
    cell: row => (
      <span
        style={{
          minWidth: '80px',
          textAlign: 'center',
          borderRadius: '20px',
          padding: '4px 10px',
          backgroundColor: row.stream_type === 'youtube' ? '#FF0000' : '#00BCD4',
          color: '#FFFFFF',
          fontSize: '11px',
          fontWeight: '600',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          textTransform: 'uppercase'
        }}
      >
        {row.stream_type === 'youtube' ? 'YouTube' : 'CCTV'}
      </span>
    ),
  },
  {
    name: 'Stream Category',
    selector: row => row.stream_category,
    sortable: true,
    center: true,
    width: '150px',
    style: cellStyle,
    cell: row => {
      const category = row.stream_category || 'live_darshan';
      const config = streamCategoryConfig[category] || streamCategoryConfig.live_darshan;
      return (
        <span
          style={{
            minWidth: '100px',
            textAlign: 'center',
            borderRadius: '20px',
            padding: '4px 10px',
            backgroundColor: config.color,
            color: '#FFFFFF',
            fontSize: '11px',
            fontWeight: '600',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            border: '1px solid rgba(255, 255, 255, 0.1)'
          }}
        >
          {config.label}
        </span>
      );
    },
  },
  {
    name: 'Temple/Teertha or Saint Name',
    center: true,
    selector: row => row.temple_name,
    sortable: true,
    width: '250px',
    style: cellStyle,
    cell: row => (
      <div style={{ 
        ...cellStyle,
        fontWeight: '500',
        width: '100%',
        textAlign: 'center'
      }}>
        {row.temple_name}
      </div>
    ),
  },
  {
    name: 'Stream Title',
    center: true,
    selector: row => row.stream_title,
    sortable: true,
    width: '220px',
    style: cellStyle,
    cell: row => (
      <div style={{ 
        ...cellStyle,
        color: '#5662F6',
        fontWeight: '500',
        width: '100%',
        textAlign: 'center'
      }}>
        {row.stream_title}
      </div>
    ),
  },
  {
    name: 'Stream ID',
    center: true,
    selector: row => row.stream_identifier,
    sortable: true,
    width: '180px',
    style: cellStyle,
    cell: row => (
      <div style={{ 
        ...cellStyle,
        fontFamily: 'monospace',
        fontSize: '12px',
        color: '#666',
        width: '100%',
        textAlign: 'center'
      }}>
        {row.stream_identifier}
      </div>
    ),
  },
  {
    name: 'Status',
    center: true,
    selector: row => row.is_active,
    sortable: true,
    width: '100px',
    style: cellStyle,
    cell: row => (
      <span
        style={{
          minWidth: '60px',
          textAlign: 'center',
          borderRadius: '20px',
          padding: '4px 8px',
          backgroundColor: row.is_active ? '#4CAF50' : '#9E9E9E',
          color: '#FFFFFF',
          fontSize: '10px',
          fontWeight: '600',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}
      >
        {row.is_active ? 'Active' : 'Archived'}
      </span>
    ),
  },
  {
    name: 'CCTV Status',
    center: true,
    selector: row => row.stream_status,
    sortable: true,
    width: '130px',
    id: 'stream_status',
    style: cellStyle,
    cell: row => {
      // Only show for CCTV streams
      if (row.stream_type !== 'cctv') {
        return <span style={{ color: '#999', fontSize: '12px', textAlign: 'center' }}>N/A</span>;
      }
      
      const statusColors = {
        'active': '#00C853',
        'inactive': '#9E9E9E',
        'error': '#F44336'
      };
      
      return (
        <span
          style={{
            minWidth: '70px',
            textAlign: 'center',
            borderRadius: '20px',
            padding: '4px 8px',
            backgroundColor: statusColors[row.stream_status] || '#9E9E9E',
            color: '#FFFFFF',
            fontSize: '10px',
            fontWeight: '600',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            border: '1px solid rgba(255, 255, 255, 0.1)'
          }}
        >
          {row.stream_status?.toUpperCase() || 'UNKNOWN'}
        </span>
      );
    },
  },
  {
    name: 'Featured',
    center: true,
    selector: row => row.is_featured,
    sortable: true,
    width: '100px',
    style: cellStyle,
    cell: row => (
      <span style={{ fontSize: '14px' }}>
        {row.is_featured ? 'Yes' : 'No'}
      </span>
    ),
  },
  {
    name: 'Created Date',
    center: true,
    selector: row => row.created_at,
    sortable: true,
    width: '120px',
    style: cellStyle,
  },
  {
    name: 'Action',
    center: true,
    selector: row => row.action,
    sortable: false,
    width: '155px',
    id: 'action',
    style: cellStyle,
  }
];